export enum ActionTypes {
  REQUEST = "@modelos-diarios/REQUEST",
  SUCCESS = "@modelos-diarios/SUCCESS",
  FAILURE = "@modelos-diarios/FAILURE",
}
